// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AANL","fullView":"styles_fullView__3ePdN"};